import React from "react";
import { View } from "react-native";
import { MoonSkeleton, SupportingSubtitleText } from "@louise/moon-ui";
import { useTranslations } from "@src/packages/i18n";

/**
 * "What people say" placeholder body. The "Coming soon" badge lives inline with
 * the section title (in ClinicDetailScreen); here we just set expectations with
 * a one-line description and a short loading skeleton. No fabricated content.
 */
export default function ClinicSentimentCard() {
  const t = useTranslations();
  return (
    <View style={{ gap: 12 }}>
      <SupportingSubtitleText style={{ marginTop: 0 }}>
        {t("access.sentiment.soon_body")}
      </SupportingSubtitleText>

      <View style={{ gap: 8 }}>
        <MoonSkeleton width="100%" height={9} />
        <MoonSkeleton width="72%" height={9} />
      </View>
    </View>
  );
}
